import { render, staticRenderFns } from "./AllPromptFamilies.vue?vue&type=template&id=4ce415c4&"
import script from "./AllPromptFamilies.vue?vue&type=script&lang=js&"
export * from "./AllPromptFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports